import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import exclamationMark from '../../icons/exclamationMark.svg';
import Tooltip from '../../../../Shared/Tooltip/Tooltip';
import Config from 'app/Config';

function DataProduct({ activeTab, loginData, epiData, equipmentsInternet, equipmentsTv, indexProdact, selectTabProdact, isShowPage }) {
    
    if(selectTabProdact === null) return;
    const [showPopup, setShowPopUp] = useState(false);
    return (
        <>
            {isShowPage && (
                <div className='container-equipment'>
                {selectTabProdact?.length >= 1 &&
                    selectTabProdact.some(item => 
                        item.equipmentAddress?.street &&
                        item.equipmentAddress?.houseNumber &&
                        item.equipmentAddress?.apprartmentNumber) && (
                        <div className="product-description">{indexProdact === 0 ? epiData?.secTitleInternet :  epiData?.secTitleTv}</div>
                )}

                    <div className="container-address-square">
                        {selectTabProdact?.length >= 1 &&
                            selectTabProdact.map((product, productIndex) => (
                                <div key={productIndex} className='wrapper-address-square'>
                                    <div className='information-address'>
                                    {product?.equipmentAddress?.street &&
                                    product?.equipmentAddress?.houseNumber &&
                                    product?.equipmentAddress?.apprartmentNumber && (
                                        <span>
                                            {product?.equipmentAddress?.street} {product?.equipmentAddress?.houseNumber}, דירה {product?.equipmentAddress?.apprartmentNumber}, {product?.equipmentAddress?.city}
                                        </span>
                                    )} 
                                    </div>
                                    {product?.relatedItems?.map((item, itemIndex) => (
                                        <div className="wrapper-square" key={itemIndex}>
                                            <div className="container-prodact">
                                            <Image src={Config.epiBaseUrl + (item.imageProduct || (item.serialNumber ? epiData.defaultImageCode.expandedValue.url : epiData.defaultImage.expandedValue.url))} alt="product icon" />
                                            <div className="product-information">
                                                    <div>{item.itemName}</div>
                                                    {item.serialNumber &&
                                                    <div className="wrapper-number">
                                                        <div className='number'>מספר סידורי: ({item.serialNumber})</div>
                                                        <button>
                                                            <Image src={exclamationMark} alt="Exclamation Icon" id={`warning-${itemIndex}`} />
                                                        </button>
                                                        <Tooltip
                                                            text={'בדקו את המדבקה בתחתית הנתב, המספר הסידורי ממוקם בדיוק מעל או מתחת לברקוד'}
                                                            target={`warning-${itemIndex}`}
                                                            placement={'top'}
                                                            cellcomdefault={true}
                                                            >
                                                        </Tooltip>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                    </div>
                </div>
              
            )}
        </>
    );
    
}

const mapStateToProps = (state) => ({
    epiData: state?.equipmentMinePage?.epiData,
    loginData: state.authentication.loginData,
    equipmentsInternet: state.equipmentMinePage.equipmentsInternet,
    equipmentsTv: state.equipmentMinePage.equipmentsTv,
    indexProdact: state.equipmentMinePage.indexProdact,
    selectTabProdact:state.equipmentMinePage.selectTabProdact,
});

const mapDispatchToProps = {  };


export default connect(mapStateToProps, mapDispatchToProps)(DataProduct);
